"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "st0",
          d: "M100,25.2"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M189.5,110.1c0,58.5-30.9,89.4-89.5,89.4c-58.5,0-89.4-30.9-89.4-89.4c0-48.7,22-78.8,63.6-87.1\r c2.5-0.5,4.9,1.1,5.4,3.6c0.2,1.2,0,2.4-0.7,3.5c-0.7,1-1.7,1.7-2.9,2c-37.3,7.4-56.2,33.7-56.2,78c0,53.2,27,80.2,80.2,80.2\r c53.2,0,80.2-27,80.2-80.2c0-45-19.4-71.3-57.7-78.3c-1.2-0.2-2.3-0.9-3-1.9c-0.7-1-1-2.2-0.7-3.5c0.2-1.2,0.9-2.3,1.9-3\r c1-0.7,2.2-1,3.5-0.7C166.9,30.5,189.5,60.7,189.5,110.1z"
          })
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M104.6,5.1v60.3c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6V5.1c0-2.5,2.1-4.6,4.6-4.6S104.6,2.6,104.6,5.1z"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "st0",
          d: "M100,25.2"
        })
      })
    })]
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M100,199.5c-56.6,0-87.8-31.2-87.8-87.8c0-60.4,34.2-79.9,62.8-85.6c4.4-0.9,8.6,2,9.5,6.4c0.9,4.4-2,8.6-6.4,9.5\r c-33.5,6.7-49.8,29.5-49.8,69.7c0,48.2,23.4,71.6,71.6,71.6c48.2,0,71.7-23.4,71.7-71.6c0-40.8-16.8-63.6-51.2-70\r c-4.4-0.8-7.3-5-6.5-9.4c0.8-4.4,5-7.3,9.4-6.5c29.4,5.4,64.5,24.6,64.5,85.9C187.8,168.3,156.6,199.5,100,199.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M99.6,75.9c-4.5,0-8.1-3.6-8.1-8.1V8.6c0-4.5,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1v59.2C107.7,72.3,104.1,75.9,99.6,75.9z"
  })]
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M100,199.5c-57.2,0-88.7-31.5-88.7-88.7c0-61,34.5-80.7,63.4-86.4c4.4-0.9,8.7,2,9.6,6.4c0.9,4.4-2,8.7-6.4,9.6\r c-33.8,6.7-50.3,29.8-50.3,70.4c0,48.7,23.7,72.4,72.4,72.4c48.7,0,72.4-23.7,72.4-72.4c0-41.2-16.9-64.3-51.7-70.7\r c-4.4-0.8-7.4-5.1-6.6-9.5c0.8-4.4,5.1-7.4,9.5-6.6c29.7,5.4,65.1,24.9,65.1,86.7C188.7,168,157.2,199.5,100,199.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M167.8,111.1c0,43.7-24.1,67.8-67.8,67.8c-4.2,0-8.1-0.2-11.9-0.6c-36.4-4-56.3-27.5-56.3-67.2c0-40.2,20.3-63.8,57.6-67.3\r v22.8c0,5.6,4.6,10.2,10.2,10.2c5.6,0,10.2-4.6,10.2-10.2V43.7c2.7,0.2,5.2,0.6,7.6,1c0.2,0,0.4,0.1,0.6,0.1\r C140.7,48.9,167.8,63.8,167.8,111.1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M105.7,6.7v59.8c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2V6.7c0-3.4,2.8-6.2,6.2-6.2C103,0.5,105.7,3.3,105.7,6.7z"
  })]
});

var Apagar = function Apagar(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Apagar-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '0 0 200 200';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Apagar;
exports["default"] = _default;

//# sourceMappingURL=index.js.map